import React, { useEffect } from 'react';
import { Icon } from 'rsuite';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRelatedGuestsForField } from '../../../redux/sagas/routines';
import { getRelatedGuestsForField } from '../../../redux/Guest/selectors/related-guests';
import pagePathToUrl from '../../../helpers/pagePathToUrl';
import formatFullName from '../../../helpers/formatFullName';
import { guestsViewPath } from '../../../routes/Paths';
import { GuestRelationHeading } from '../ViewElements';

const RelatedGuests = ({ guestId, field, showHeading, ...props }) => {
  const dispatch = useDispatch();
  const guests = useSelector(state => getRelatedGuestsForField(state, field));

  useEffect(() => {
    dispatch(fetchRelatedGuestsForField({ guestId, field }));
  }, []);

  if (isEmpty(guests)) return '';

  return (
    <div style={{ display: 'inline-block' }}>
      {showHeading && (
        <GuestRelationHeading>Associated Record(s)</GuestRelationHeading>
      )}
      {map(
        ({ id, firstname, lastname }) => (
          <a
            {...props}
            key={`related-${id}`}
            target="_blank"
            rel="noopener noreferrer"
            href={pagePathToUrl(guestsViewPath, { id, section: 'primary' })}
            style={{ display: 'block' }}
          >
            {formatFullName([firstname, lastname])}{' '}
            <Icon icon="external-link" />
          </a>
        ),
        guests
      )}
    </div>
  );
};

RelatedGuests.propTypes = {
  guestId: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  showHeading: PropTypes.bool
};

RelatedGuests.defaultProps = {
  showHeading: false
};

export default RelatedGuests;
